

     





const checkboxes = document.querySelectorAll('input[type="checkbox"]');
const texts = document.querySelectorAll('.checklist-heading');

checkboxes.forEach((checkbox, index) => {
    checkbox.addEventListener('change', function() {
        texts[index].style.color = this.checked ? '#039640' : 'black';
        
    });
});



 
   
 









// // Add this code to your theme's JavaScript file (e.g., theme.js)

//   {
//     "@context": "http://schema.org",
//     "@type": "Article",
//     "articleBody": {{ article.content | strip_html | json }},
//     "mainEntityOfPage": {
//       "@type": "WebPage",
//       "@id": {{ request.origin | append: page.url | json }}
//     },
//     "headline": {{ article.title | json }},
//     {% if article.excerpt != blank %}
//       "description": {{ article.excerpt | strip_html | json }},
//     {% endif %}
//     {% if article.image %}
//       "image": [
//         {{ article | image_url: width: 1920 | prepend: "https:" | json }}
//       ],
//     {% endif %}
//     "datePublished": {{ article.published_at | date: '%Y-%m-%dT%H:%M:%SZ' | json }},
//     "dateCreated": {{ article.created_at | date: '%Y-%m-%dT%H:%M:%SZ' | json }},
//     "author": {
//       "@type": "Person",
//       "name": {{ article.author | json }}
//     },
//     "publisher": {
//       "@type": "Organization",
//       "name": {{ shop.name | json }}
//     }
//   }



